import { render } from "./Cessions.vue?vue&type=template&id=10813abc"
import script from "./Cessions.vue?vue&type=script&lang=js"
export * from "./Cessions.vue?vue&type=script&lang=js"

import "./Cessions.vue?vue&type=style&index=0&id=10813abc&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__